<template>
  <vx-card>
    <vs-row>
      <vs-col class="mb-6 flex" vs-align="center">
        <h5><i class="dot"></i>사업장 상세</h5>
      </vs-col>
    </vs-row>
    <vs-row style="margin-bottom: 150px;">
      <vs-col class="w-1/2">
        <vs-row class="flex mb-4" vs-align="center">
          <h5 class="vx-col sm:w-2/12">계약코드</h5>
          <ml-input class="vx-col sm:w-8/12 w-full " placeholder="계약코드" v-model="form.inputA_1"/>
        </vs-row>
        <vs-row class="flex mb-4" vs-align="center">
          <h5 class="flex vx-col sm:w-2/12">사업장명</h5>
          <ml-input class="vx-col sm:w-8/12 w-full " placeholder="사업장명" v-model="form.inputA_2"/>
        </vs-row>
        <vs-row class="flex mb-4" vs-align="center">
          <h5 class="flex vx-col sm:w-2/12">지역</h5>
          <ml-input class="vx-col sm:w-8/12 w-full " placeholder="지역" v-model="form.inputA_3"/>
        </vs-row>
      </vs-col>
      <vs-col class="w-1/2">
        <vs-row class="flex mb-4" vs-align="center">
          <h5 class="flex vx-col sm:w-2/12">안전담당부서</h5>

          <vs-col class="sm:w-8/12 w-full ">
            <ml-input class="w-full" v-model="form.inputA_4" />
          </vs-col>
        </vs-row>
        <vs-row class="flex mb-4" vs-align="center">
          <h5 class="flex vx-col sm:w-2/12">안전보건부서장</h5>
          <vs-col class="sm:w-8/12 w-full ">
            <member-selector v-model="form.inputA_5"/>
          </vs-col>
        </vs-row>
        <vs-row class="flex mb-4" vs-align="center">
          <h5 class="flex vx-col sm:w-2/12">안전보건담당자</h5>
          <vs-col class="sm:w-8/12 w-full ">
            <member-selector v-model="form.inputA_6"/>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col class="flex">
        <div class="mr-4">
          <h5 class="flex vx-col sm:w-2/12 mb-2" style="white-space: nowrap">사업장조감도</h5>
          <div style="width: 300px; height: 300px;">
            <file-uploader
              v-if="!isPrint"
              type="only-image"
              v-model="form.inputB_1"
            />
            <img class="w-full h-full" v-else :src="form.inputB_1.thumb" />
          </div>
        </div>
        <div class="mr-4">
          <h5 class="flex vx-col sm:w-2/12 mb-2" style="white-space: nowrap">사업장약도</h5>
          <div style="width: 300px; height: 300px;">
            <file-uploader
              v-if="!isPrint"
              type="only-image"
              v-model="form.inputB_2"
            />
            <img class="w-full h-full" v-else :src="form.inputB_2.thumb" />
          </div>
        </div>
        <div>
          <h5 class="flex vx-col sm:w-2/12 mb-2" style="white-space: nowrap">사업장사진</h5>
          <div style="width: 300px; height: 300px;">
            <file-uploader
              v-if="!isPrint"
              type="only-image"
              v-model="form.inputB_3"
            />
            <img class="w-full h-full" v-else :src="form.inputB_3.thumb" />
          </div>
        </div>
      </vs-col>
    </vs-row>


<!--    <popup-plan-project-->
<!--      :popupActive="popupActive"-->
<!--      :value="selectPlanProject"-->

<!--      @popupActiveSync="popupActiveSync"-->
<!--      @register="registerPlanManagerment"-->
<!--      @update="registerPlanManagerment"-->
<!--      @delete="registerPlanManagerment"-->
<!--    ></popup-plan-project>-->

<!--    <popup-project-setting v-model="showPopupProjectSetting"/>-->

  </vx-card>
</template>

<script>
import config from '/public/config'
import VueCookie from 'vue-cookie'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'

export default {
  name: 'PlanProjectInfo',
  components: {
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler (value) {
        this.form.inputA_2 = this.value && this.value.inputA_2 ? this.value.inputA_2 : this.board.projectTitle
      }
    },
    value: {
      important: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        value.title = value.inputA_2
        this.$emit('input', value)
      }
    }
  },
  data () {
    return {
      form: {
        inputA_1: '',
        inputA_2: '',
        inputA_3: '',
        inputA_4: '',
        inputA_5: '',
        inputA_6: '',

        inputB_1: {},
        inputB_2: {},
        inputB_3: {},
      },
    }
  },
}
</script>

<style scoped>

</style>
